import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getAgrotechnicalEventsField.success: {
            return action.payload.errors;
        }

        case constants.getAgrotechnicalEventsField.error: {
            return initialState;
        }

        default:
            return state;
    }
}
